"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f1827 = void 0;
exports.f1827 = {
    "ܣܘܪܝܝܐ": [
        7277
    ]
};
